import type { ReactNode } from "react";
import { SidebarProvider as SharedSidebarProvider } from "@denhartog/ui";

export { useSidebar } from "@denhartog/ui";

export function SidebarProvider({ children }: { readonly children: ReactNode }) {
  return <SharedSidebarProvider storageKey="sidebar-collapsed">{children}</SharedSidebarProvider>;
}
